import { DateTime } from 'luxon';

// TODO: find out why this is being set as en-US
let locale = 'en-AU'; // window.navigator.language;

function isInt(value) {
    if (isNaN(value)) {
        return false;
    }
    var x = parseFloat(value);
    return (x | 0) === x;
}

function formatDate(value) {
    if (value === null) return "";
    var dateTime = DateTime.fromISO(value, { setZone: true });
    var utcDateTime = dateTime.toUTC().setLocale(locale);
    var utcPlusOffset = utcDateTime.plus({ minutes: dateTime.offset });
    return utcPlusOffset.toLocaleString(navigator.language, { dateStyle: 'short' });
}

function formatDateTime(value) {
    if (value === null) return "";
    var dateTime = DateTime.fromISO(value, { setZone: true });
    var utcDateTime = dateTime.toUTC().setLocale(locale);
    var utcPlusOffset = utcDateTime.plus({ minutes: dateTime.offset });
    var datePart = utcPlusOffset.toLocaleString(navigator.language, { dateStyle: 'short' });
    var timePart = utcPlusOffset.toLocaleString(DateTime.TIME_SIMPLE);
    var offset = formatOffset(dateTime.offset);

    // TODO: Only format offset if it's not the same as the current offset.
    return `${datePart} ${timePart.split(' ').join('')} ${offset}`.trimEnd();
}

function getDate(value) {
    if (value === null || typeof value === "undefined") return "";

    var dateTime = DateTime.fromISO(value, { setZone: true });
    var utcDateTime = dateTime.toUTC().setLocale(locale);
    var utcPlusOffset = utcDateTime.plus({ minutes: dateTime.offset });

    var datePart = utcPlusOffset.toLocaleString(DateTime.DATE_SHORT);
    return datePart;
}

function formatTime(value) {
    if (typeof value === 'undefined' || value === null) {
        return "";
    }

    return DateTime
        .fromISO(value)
        .setLocale(locale)
        .toLocaleString(DateTime.TIME_SIMPLE);
}

function formatTimeWithOffset(value) {
    if (typeof value === 'undefined' || value === null) {
        return "";
    }

    return DateTime
        .fromISO(value, { setZone: true })
        .toLocaleString(DateTime.TIME_WITH_SHORT_OFFSET);
}

function setTime(value, time) {
    var dateTime = DateTime.fromISO(value, { setZone: true });
    var date = dateTime.toISODate();
    var offset = toIsoOffset(dateTime.offset);
    return date + 'T' + time + offset;
}

function addDays(value, days) {
    var dateTime = DateTime.fromISO(value, { setZone: true }).plus({ days: days });
    return dateTime.toISO();
}

function formatTimespan(value) {
    if (typeof value === 'undefined' || value === null) {
        return "";
    }

    return DateTime
        .fromISO(value)
        .set({ milliseconds: 0 })
        .toISOTime({ suppressMilliseconds: true, includeOffset: false });
}

function formatOffset(offset) {
    if (offset === 0) return 'UTC';

    var hours = parseInt(Math.abs(offset / 60));
    var minutes = Math.abs(offset % 60);
    var prefix = offset > 0 ? '+' : '-';

    if (minutes === 0) {
        minutes = '';
    }
    else if (minutes < 10) {
        minutes = ':0' + minutes;
    }
    else {
        minutes = ":" + minutes;
    }

    return 'UTC' + prefix + hours + minutes;
}

function toIsoOffset(offset) {
    if (offset === 0) return 'Z';

    var hours = parseInt(Math.abs(offset / 60));
    var minutes = Math.abs(offset % 60);
    var prefix = offset > 0 ? '+' : '-';
    if (hours < 10) hours = '0' + hours;
    if (minutes < 10) minutes = '0' + minutes;

    return prefix + hours + ':' + minutes;
}

function tryParseOffset(offset) {
    // We expect the time offset to be something like this:
    // +8, -8, 8, 8:00, 08:00, +8:00, +08:00, -08:00, Z
    if (offset == null) {
        return { isValid: false };
    }

    if (offset == "Z") {
        // Z = Zulu = UTC+0:00
        return { isValid: true, offset: 0 };
    }

    // value in minutes.
    var value = null;

    if (isInt(offset)) {
        value = parseInt(Number(offset)) * 60;
    }
    else {
        var matches = offset.match(/^([+-]?)(\d?\d):(\d\d)$/);
        if (matches == null) {
            return { isValid: false };
        }
        else {
            var minutes = Number(matches[3]);
            if (minutes >= 60) {
                return { isValid: false };
            }

            var sign = matches[1] === "-" ? -1 : 1;
            value = sign * (Number(matches[2]) * 60 + minutes);
        }
    }

    if (value < -12 * 60 || value > 14 * 60) {
        return { isValid: false };
    }

    return { isValid: true, offset: value };
}

function getCurrentDateIso() {
    var now = DateTime.local();
    return toDateIso(now);
}

function toDateIso(date) {
    return date.toISODate() + 'T00:00:00' + toIsoOffset(date.offset);
}

function getDifference(value1, value2) {
    var dateTime1 = DateTime.fromISO(value1, { setZone: true });
    var dateTime2 = DateTime.fromISO(value2, { setZone: true });
    return dateTime1.diff(dateTime2);
}

export default { formatDate, formatDateTime, getDate, formatTime, formatTimeWithOffset, formatTimespan, formatOffset, toIsoOffset, tryParseOffset, getCurrentDateIso, toDateIso, setTime, getDifference, addDays };
